import '@/plugins/vant/index'
import '@/plugins/components/views'

export default {}
